import { EnumResponse } from '@/api/services/common.dto'

export enum CommonDeviceTypeEnum {
    ASSEMBLERS = 'ASSEMBLERS',
    MICROTOMES = 'MICROTOMES',
    PROCESSOR = 'PROCESSOR',
    SCANNER = 'SCANNER',
    STAINNING_MACHINE = 'STAINNING_MACHINE',
    ANALYSIS = 'ANALYSIS'
}

export interface CommonDeviceTypeEnumResponse extends EnumResponse {
    code: CommonDeviceTypeEnum
}
